import { ELSInlineLoader } from '@els/els-ui-common-react';
import { ELSIconV2 } from 'components/common';
import InfoIcon from 'components/common/info-icon/InfoIcon';
import { onKeyDownHandler } from 'helpers/ui.helper';
import { kebabCase } from 'lodash';
import { Link } from 'react-router-dom';
var EngagementInsightCard = function (_a) {
    var id = _a.id, children = _a.children, footerText = _a.footerText, title = _a.title, subtitle = _a.subtitle, footerTo = _a.footerTo, footerAriaLabel = _a.footerAriaLabel, onFooterClick = _a.onFooterClick, isInfoIconShown = _a.isInfoIconShown, isLoading = _a.isLoading;
    var onKeyDown = function (e) { return onKeyDownHandler(e, function () { return onFooterClick === null || onFooterClick === void 0 ? void 0 : onFooterClick(); }); };
    var footer = footerTo ? (<Link to={footerTo} onClick={onFooterClick} className="c-cw-engagement-insight-card__footer" aria-label={footerAriaLabel}>
      {footerText}
      <ELSIconV2 sprite="ChevronRight" id="ChevronRight" className="u-els-padding-left-1o2"/>
    </Link>) : (<div tabIndex={0} role="button" className="c-cw-engagement-insight-card__footer" aria-label={footerAriaLabel} onClick={onFooterClick} onKeyDown={onKeyDown}>
      {footerText}
      <ELSIconV2 sprite="ChevronRight" id="ChevronRight" className="u-els-padding-left-1o2"/>
    </div>);
    return (<div className="c-cw-engagement-insight-card">
      {title && (<div className="c-cw-engagement-insight-card__header">
          <div className="c-cw-engagement-insight-card__header-title">
            <h3 className="c-cw-engagement-insight-card__header-title-main">
              {title}
              {isInfoIconShown && <InfoIcon size="s" customClassName="u-els-color-secondary u-els-padding-left-1o2 u-els-margin-bottom-1o8" dashboard="cw" id={kebabCase(id)}/>}
            </h3>
            {subtitle && <h5 className="c-cw-engagement-insight-card__header-title-sub">{subtitle}</h5>}
          </div>
        </div>)}
      <div className="c-cw-engagement-insight-card__content">
        {isLoading ? (<div className="u-els-display-flex">
            <ELSInlineLoader />
          </div>) : (children)}
      </div>
      {footer}
    </div>);
};
export default EngagementInsightCard;
